import Header from "layout/Header/Header";
import Main from "layout/Main/Main";
import SideNav from "layout/SideNav/SideNav";
import React, { FC, ReactElement, useContext } from "react";
import { HeaderContext } from "utils/context/HeaderContext";
import ErrorBoundary from "newComponents/Errors/ErrorBoundry";
import { useRouter } from "next/router";
import Script from "next/script";
import {useSelector} from "react-redux";
import {makeSelectCurrentUser} from "../../Store/user/selectors";

interface IProps {
  children: ReactElement;
}

export const LoggedInWrapper: FC<IProps> = ({ children }) => {
  const { title, icon, headerTabs, isBackButton } = useContext(HeaderContext);
  const router = useRouter();
  setTimeout(function(){
    document.getElementById('zohohc-asap-web-helper') ? document.getElementById('zohohc-asap-web-helper').style.opacity = '1' : null;
  }, 5000);
  return (
    <div className="layout-wrapper">
      <SideNav />
      <Header title={title} iconName={icon} headerTabs={headerTabs} back={isBackButton} />
      <ErrorBoundary router={router}>
        <Main>{children}</Main>
      </ErrorBoundary>
        <Script>
            {`
                (function(apiKey){
                    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
                    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
                        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
                })('010e65dc-ce76-4697-47d6-67e316112fec');
            `}
        </Script>
    </div>
  );
};
